import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import SubscriptionAddonInstaller from 'modules/app_store/lib/SubscriptionAddonInstaller'
import subscriptionAddons from 'modules/billing/store/collections/subscriptionAddons'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

export const useCompanyPageStatusToggle = () => {
  const { company } = useCurrentSession()
  const subscriptionAddon = subscriptionAddons.find(
    (addon: SubscriptionAddon) => addon.attributes.id === 'ats_careers_page'
  )
  const isInstalled = subscriptionAddon?.attributes.enabled
  const needsPlanUpgrade = !subscriptionAddon?.attributes.available_for_current_plan
  const { navigation } = useNavigation()

  const { running, performAction } = useAsyncAction(async () => {
    if (!subscriptionAddon) return
    const installer = new SubscriptionAddonInstaller(subscriptionAddon, navigation)
    await installer.toggle()
  })

  const toggleAddonStatus = () => {
    const eventName = isInstalled
      ? trackingEvents.appStore.uninstallAnyAppSuccess
      : trackingEvents.appStore.installAnyAppSuccess

    performAction()
    track(eventName, {
      app_name: subscriptionAddon?.id,
      app_page_path: location.pathname,
      app_page_url: window.location.href,
    })
  }

  useAsyncData(() => subscriptionAddons.fetch(), [])

  return {
    running,
    isInstalled,
    isConfigured: !!company.slug && !!company.countryFactorialDomain,
    toggleAddonStatus,
    subscriptionAddon,
    needsPlanUpgrade,
  }
}
